<script>
    export let showBreak = true;
    let text = null;
    $: num = parseFloat(text);
    $: isValid = (
      Number.isInteger(num) &&
      num > 0 &&
      5_000_000_000 > num
    )
</script>

<h3>
    Enter a Number
</h3>
<input bind:value={text} />
{#if showBreak}
    <br />
{/if}

<button class = {text == null ? 'invis' : isValid ? 'fade-in' : 'fade-out'}><a class = "btn" href = {`/${text}`}>Visit Page</a></button>

<style>
  .invis {
    opacity: 0%;
  }

  .fade-in {
    opacity: 0%;
    animation: fadeIn .5s linear forwards;
  }

  .fade-out {
    opacity: 100%;
    animation: fadeOut .5s linear forwards;     
  }

  @keyframes fadeIn {
    100% { opacity: 100%; }
  }

  @keyframes fadeOut {
    100% { opacity: 0%; }
  }
</style>